import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { INotifications, TNotification } from '../core/notifications';
import { Notifications } from './notifications';

type NotificationsBarRenderProps = {
  store: INotifications;
  children: (notifications: ReactNode) => ReactNode;
};
export const NotificationsBarRender = observer(
  ({ store, children }: NotificationsBarRenderProps) => {
    const hasNotifications = store.messages.length > 0;

    const onClose = (messageId: Pick<TNotification, 'id'>) => store.removeMessage(messageId);
    return hasNotifications ? (
      <>{children(<Notifications messages={store.messages} onClose={onClose} />)}</>
    ) : null;
  },
);
